export const eventTracking = (position: string, action: string, buttonText: string) => {
  if (window && window.analytics && window.analytics.track) {
    window.analytics.track('behaviour_tracking', {
      category: 'blog',
      position,
      action,
      button_text: buttonText,
      user_type: 'customer',
    });
  }
};
